export const backgroundImageStyle = (
  image: string | undefined | null | false
) => {
  if (!image) return

  return {
    backgroundImage: `url("${image}")`,
  }
}
